module.exports = __webpack_public_path__ + "2ed0cabc98b9ae7c273dada03f81bd19.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/12_column_xlarge_x1/public/history/4.jpg
// module id = 330
// module chunks = 0